import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import cx from 'clsx';

const useStyles = makeStyles((theme: Theme) => {
  return {
    center: {
      textAlign: 'center',
      margin: '0 auto'
    },
    card: {
      padding: theme.spacing(3),
      paddingBottom: 0
    },
    padding: {
      padding: theme.spacing(2)
    },
    iconContainer: {
      verticalAlign: 'middle',
      '& svg': {
        color: theme.palette.success.main
      }
    },
    largePadding: {
      paddingLeft: theme.spacing(1.5)
    },
    largeIcon: {
      '& svg': {
        fontSize: theme.typography.pxToRem(36)
      },
      '& img': {
        height: theme.typography.pxToRem(36)
      }
    },
    smallIcon: {
      '& svg': {
        fontSize: theme.typography.pxToRem(12)
      },
      '& img': {
        height: theme.typography.pxToRem(12)
      }
    },
    smallPadding: {
      paddingLeft: theme.spacing(0.5)
    },
    large: {
      ...theme.typography.h4
    },
    small: {
      ...theme.typography.caption
    },
    shrinkTopPadding: {
      paddingTop: theme.spacing(0.5)
    },
    adjustSubtitle: {
      paddingLeft: theme.spacing(5)
    }
  };
});

export interface CategoryHeaderProps {
  label: string;
  icon: React.ReactNode;
  size?: 'small' | 'large';
  className?: string;
  card?: boolean;
  center?: boolean;
  disablePadding?: boolean;
}
const CategoryHeader: React.FC<CategoryHeaderProps> = ({
  label,
  icon,
  className,
  center,
  card,
  disablePadding,
  size = 'large',
  children
}): React.ReactElement => {
  const classes = useStyles();
  const imageIcon = typeof icon === 'string' ? <img src={icon} alt="icon" /> : null;
  return (
    <div
      className={cx({
        [classes.center]: center,
        [classes.padding]: !disablePadding && !card,
        [classes.card]: card,
        [classes.shrinkTopPadding]: size === 'small',
        className
      })}
    >
      <span className={cx(classes.iconContainer, classes[`${size}Icon` as keyof typeof classes])}>
        {imageIcon || icon}
      </span>
      <Typography
        className={cx(classes[size], classes[`${size}Padding` as keyof typeof classes])}
        component="span"
      >
        {label}
      </Typography>
      {children && (
        <Typography variant="subtitle1" className={classes.adjustSubtitle}>
          {children}
        </Typography>
      )}
    </div>
  );
};

export default CategoryHeader;
